import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

import { fetchPlaceType, updatePlaceType } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

export default function PlaceTypeEditPage() {
  const { businessDomainId, placeTypeId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [form, setForm] = useState({ placeTypeName: "", placeTypeDescription: "" });
  const [fullData, setFullData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const d = await fetchPlaceType(placeTypeId);
        setFullData(d);
        setForm({
          placeTypeName: d.placeTypeName || "",
          placeTypeDescription: d.placeTypeDescription || "",
        });
      } catch (e) { notify.apiError(e); }
    })();
  }, [placeTypeId]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { ...fullData, ...form };
      await updatePlaceType(payload);
      notify.success(t("message.update.success"));
      navigate(`/design/${businessDomainId}/place-types/${placeTypeId}`);
    } catch (err) { notify.apiError(err); }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>{t("placeType.edit.title")}</Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField fullWidth required multiline label={t("placeType.name")}
              name="placeTypeName" value={form.placeTypeName} onChange={handleChange} />
          </Grid>
          <Grid size={12}>
            <TextField fullWidth multiline rows={3} label={t("placeType.description")}
              name="placeTypeDescription" value={form.placeTypeDescription} onChange={handleChange} />
          </Grid>
        </Grid>
        <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
          <Button variant="contained" type="submit">{t("common.save")}</Button>
          <Button variant="outlined" onClick={() => navigate(`/design/${businessDomainId}/place-types/${placeTypeId}`)}>{t("common.cancel")}</Button>
        </Box>
      </Box>
    </Box>
  );
}
